import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import OKIcon from "@material-ui/icons/CheckCircleOutlined";

const styles = (theme) => ({
  content: {
    backgroundColor: "white",
    opacity: "1",
  },
});

class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }

  handleCancel(e) {
    e.preventDefault();
    this.props.onCloseConfirm(e, 2);
  }

  handleOk(e) {
    e.preventDefault();
    this.props.onCloseConfirm(e, 1);
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        <Dialog
          style={{ textAlign: "center" }}
          open
          fullScreen={this.props.fullScreen}
          PaperProps={{
            classes: {
              root: classes.content,
            },
          }}
        >
          <DialogTitle>{this.props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography color="primary" variant="h6">
                {this.props.text}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ display: "flex", justifyContent: "center" }}>
            <Button color="primary" onClick={this.handleOk}>
              <OKIcon />
              &nbsp;{t("ok.button")}
            </Button>
            <span />
            <Button color="primary" onClick={this.handleCancel}>
              <CancelIcon />
              &nbsp;{t("cancel.button")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withTranslation()(withStyles(styles)(ConfirmDialog));
